var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entry-layout"},[_c('aside-dashboard',{staticClass:"entry-layout_sidebar"}),_vm._v(" "),_c('div',{staticClass:"entry-layout__main"},[_c('header-block'),_vm._v(" "),_c('div',{staticClass:"dashboard_content"},[_c('router-view')],1)],1),_vm._v(" "),_c('notifier-block')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }